<template>
  <BaseSectionTitle
    v-if="element.sectionTitle"
    :title="element.sectionTitle"
  />
  <!-- 
    DEV NOTE: Maybe add translateAttributeForm functionality on higher level (inside label standard object).
              More investigation is necessary as this could be used in DetailsTable (show page) in the future.
  -->
  <!-- 
    ------------------ LABEL Functionality ------------------
    label: [String] translated text for the label
    noLabel: [true/false] to not show the label
    labelRequired: [true/false] to show if the form element is required
    label: {
      label: [String] translated text for the label. Same as label
      show: [true/false] to show the label or not. Similar functionality to noLabel
      required: [true/false] to show if the form element is required. Same as labelRequired
    }
    ---------------------------------------------------------
  -->
  <BaseLabel
    v-else-if="element.label.show"
    :required="element.label.required"
    :label="element.label.label || translateAttributeForm(element.key, translationParentKey)"
    :optional="element.label.optional"
    disable-margin
  />
</template>

<script>
import { translateAttributeForm } from '@/functions/translationHelpers';

export default {
  props: {
    element: {
      type: Object,
      default: undefined,
      required: true,
    },
    translationParentKey: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    translateAttributeForm,
  },
}
</script>